import { Button, Center, Text, ThemeIcon } from "@mantine/core";
import { Logo } from "../../../layouts/Logo";
import { Link } from "react-router-dom";
import { useLanguage } from "../../../stores/LanguageStore";
import { IconX } from "@tabler/icons-react";

const SubscriptionCancelled = () => {
  const lang = useLanguage((s) => s.language);
  return (
    <Center
      w={"60vw"}
      h={"50vh"}
      style={{ flexDirection: "column" }}
      mx={"auto"}
      mt={128}
    >
      <Logo w={200} mb={64} />

      <ThemeIcon size={96} color="red" radius={"xl"} variant="light" mb={16}>
        <IconX size={64} />
      </ThemeIcon>

      <Text fz={30}>{lang.pricing.error.title}</Text>

      <Button
        variant="filled"
        mt={32}
        component={Link}
        size="lg"
        to={"/settings/subscription"}
      >
        {lang.pricing.error.back}
      </Button>
    </Center>
  );
};

export default SubscriptionCancelled;
